import React from 'react';
import HandledAirlines from './HandledAirlines';
import http from '../../../../../utils/http';
import { connect } from 'react-redux';
import events from '../../../../../utils/evemts';
import cookies from 'utils/cookies';
import { setDeleteAction } from 'store/actions/deleteAction';

class HandledAirlinesContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      airlineList: [],
      comboairlineList: [],
      locationModal: false,
      airlineFields: {},
      airlineErrors: {},
      combineAirlineFields: {},
      combineAirlineErrors: {},
      airlineId: 0,
      combinationId: 0,
      combinationList: [],
      openAddAirline: false,
      // openCombineAirline: false,
      type: 'add',
      location: false,
      locationType: false,
      station: [],
      tab: 'airlines',
    };
    this.eventSource = null;
    this.combinationEventSource = null;
  }

  async componentDidMount() {
    await this.fetchAirlines();
    await this.fetchAirlineCombination();
    this.eventSource = events('admin', 'airline');
    this.eventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      let station = parseInt(cookies.get('station'));
      if (msg.action == 'add' && msg.data?.stations?.some(stn => stn.id === station)) {
        this.setState({ airlineList: [...this.state.airlineList, msg.data] });
      }
      if (msg.action == 'update') {
        const airlineList = [...this.state.airlineList];
        const index = airlineList.findIndex(c => msg.data && c.id == msg.data.id);
        if (index > -1) {
          airlineList[index] = {
            ...msg.data,
            stations: msg.data?.stations && msg.data?.stations?.length > 0 ? msg.data.stations : airlineList[index].stations
          };
          if (!airlineList[index].stations?.some(stn => stn.id === station)) {
            airlineList.splice(index, 1);
          }
          this.setState({ airlineList });
        } else {
          if (msg.data?.stations && msg.data?.stations?.length > 0) {
            if (msg.data?.stations?.some(stn => stn.id === station)) {
              this.fetchAirlines();
            }
          }
        }
      }
    };
    this.combinationEventSource = events('admin', 'airline_combination');
    this.combinationEventSource.onmessage = (event) => {
      const msg = JSON.parse(event.data || '{}');
      if (['add', 'update', 'delete'].includes(msg.action)) {
        // this.fetchAirlineCombination();
        this.fetchAirlineCombination();
      }
    };
  }

  componentWillUnmount() {
    this.eventSource?.close();
    this.combinationEventSource?.close();
  }

  fetchAirlines = async () => {
    await http.get('/airline')
      .then((response) => {
        // handle success
        this.setState({ airlineList: response.data.data });
      });
  };

  fetchAirlineCombination = async () => {
    await http.get('/airline_combination')
      .then((response) => {
      // handle success
      // set disabled = true for airline from airlineList if present in combinationList anc create comboairlineList
        console.log('airlineList', this.state.airlineList);
        const comboairlineList = this.state.airlineList.map((airline) => {
          const isInCombination = response.data.data.some((combination) => combination.airlines.some((a) => a.id === airline.id));
          return {
            ...airline,
            disabled: isInCombination
          };
        });
        // sort mode disabled airlines to bottom of the list
        comboairlineList.sort((a, b) => a.disabled - b.disabled);
        console.log('response.data.data', response.data.data);
        console.log('comboairlineList____________________', comboairlineList);
        this.setState({ 
          comboairlineList: comboairlineList,
          combinationList: response.data.data 
        });
      });
  };

  handleClose = () => {
    this.setState({
      openAddAirline: false,
      // openCombineAirline: false,
      airlineId: false,
      combinationId: false,
      airlineFields: {},
      combineAirlineFields: {},
      type: false
    });
  };

  onChange = (e) => {
    let value = e.target.type == 'checkbox' ? e.target.checked : e.target.value;
    const name = e.target.name;
    this.setState({
      airlineFields: {
        ...this.state.airlineFields,
        [name]: value
      }
    });
  };

  onChangeCombineAirline = (e) => {
    const { name, type, checked, value } = e.target;
    console.log('onChangeCombineAirline', name, value);
    // if value greater than 2 throw error. and do not proceed
    if(name === 'airline_list' && value.length > 2) {
      console.error('You can only select up to 2 airlines.');
      return;
    }
    const newValue = type === 'checkbox' ? checked : value;
    const combineAirlineFields = {
      ...this.state.combineAirlineFields,
      [name]: newValue,
    };
    const airlineList = combineAirlineFields.airline_list || [];
    const airlineRecord = this.state.airlineList.filter((airline) =>
      airlineList.includes(airline.id)
    );

    this.setState({
      combineAirlineFields: {
        ...combineAirlineFields,
        code: airlineRecord.map((airline) => airline.code).join('-'),
      },
    });
  };

  updateAirline = async (id, data) => {
    await http.put('/airline/update/' + id, data)
      .then(() => {
        this.setState({
          airlineFields: {
            name: '',
            code: '',
            awb_pre: ''
          },
          openAddAirline: false,
          type: 'add'
        });
      });
  };

  addEditAirline = async (e) => {
    e.preventDefault();
    let formdata = { ...this.state.airlineFields };
    if (this.validation()) {
      if (this.state.airlineId) {
        this.updateAirline(this.state.airlineId, formdata);
      } else {
        await http.post('/airline/create', formdata)
          .then(() => {
            this.setState({
              airlineFields: {
                name: '',
                code: '',
                awb_pre: ''
              },
              openAddAirline: false
            });
          });
      }

    }
  };

  addAirlineCombination = async (e) => {
    console.log('combineAirlineFields', this.state.combineAirlineFields);
    e.preventDefault();
    let formdata = { 
      airlineIds: this.state.combineAirlineFields.airline_list,
      name: this.state.combineAirlineFields.name,
      code: this.state.combineAirlineFields.code
    };
    if (this.combineAirlineValidation()) {
      await http.post('/airline_combination', formdata)
        .then(() => {
          this.setState({
            combineAirlineFields: { 
              airline_list: [],
              name: '',
              code: ''
            },
            // openCombineAirline: false
          });
        });
    }
  };

  updateAirlineCombination = async (e) => {
    e.preventDefault();
    let formdata = { 
      airlineIds: this.state.combineAirlineFields.airline_list,
      name: this.state.combineAirlineFields.name,
      code: this.state.combineAirlineFields.code
    };
    if (this.combineAirlineValidation()) {
      await http.put('/airline_combination/' + this.state.combinationId, formdata)
        .then(() => {
          this.setState({
            combineAirlineFields: {
              id: null,
              airline_list: [],
              name: '',
              code: ''
            },
            openAddAirline: false,
            combinationId: false
          });
        });
    }
  };

  deleteAirlineCombination = async (id, anchorEl) => {
    this.props.setDelete({
      modal: true,
      id,
      anchorEl,
      onConfirm: async () => { await http.delete('/airline_combination/' + id)
        .then(() => {
          this.setState({
            combineAirlineFields: {
              id: null,
              airline_list: [],
              name: '',
              code: ''
            },
            // openCombineAirline: false,
            combinationId: false
          });
        });
      }
    });
  };

  handleCombineEdit = (combinationFields = {}) => {
    console.log('tab', this.state.tab);
    console.log('type',this.state.type);
    this.setState({
      tab: 'combineAirlines',
      type: 'edit',
      openAddAirline: true,
      // openCombineAirline: true,
      combinationId: combinationFields.id || false,
      combineAirlineFields: {
        id: combinationFields.id || false,
        airline_list: combinationFields.airlines?.map(airline => airline.id) || [],
        temp_airline_list: combinationFields.airlines?.map(airline => airline.id) || [],
        name: combinationFields.name || '',
        code: combinationFields.code || ''
      },
    });
  };
  

  validation = () => {
    const airlineFields = { ...this.state.airlineFields };
    const error = {};
    let formValid = true;
    if (!airlineFields.name || (airlineFields.name.trim().length === 0)) {
      formValid = false;
      error.name = true;
    }
    if (!airlineFields.code || (airlineFields.code.trim().length === 0)) {
      formValid = false;
      error.code = true;
    }
    if (airlineFields.code?.trim().length > 2 || (airlineFields.code?.trim().length < 2)) {
      formValid = false;
      error.code = 'Airline code should be two digits';
    }
    if (!airlineFields.awb_pre || (airlineFields.awb_pre.trim().length === 0)) {
      formValid = false;
      error.awb_pre = true;
    }
    if (airlineFields.awb_pre?.trim().length > 3 || airlineFields.awb_pre?.trim().length < 3) {
      formValid = false;
      error.awb_pre = 'Prefix should be three digits';
    }
    this.setState({ airlineErrors: error });
    return formValid;
  };

  combineAirlineValidation = () => {
    const combineAirlineFields = { ...this.state.combineAirlineFields };
    const error = {};
    let formValid = true;
    if (!combineAirlineFields.name || (combineAirlineFields.name.trim().length === 0)) {
      formValid = false;
      error.name = true;
    }
    if (!combineAirlineFields.code || (combineAirlineFields.code.trim().length === 0)) {
      formValid = false;
      error.code = true;
    }
    if (combineAirlineFields.airline_list && (combineAirlineFields.airline_list.length < 2 || combineAirlineFields.airline_list.length > 2)) {
      formValid = false;
      error.airline_list = 'Select exactly two airlines';
    }
    this.setState({ combineAirlineErrors: error });
    return formValid;
  };

  handleOpen = (type, airlineFields = {}, tab = this.state.tab) => {
    this.setState({
      tab,
      openAddAirline: true,
      // openCombineAirline: type === 'combine' ? true : false,
      airlineId: airlineFields.id || false,
      airlineFields,
      type: type
    });
  };

  setActive = (id, active) => {
    this.updateAirline(id, { active });
  };

  handleLocation = (locationType, v, data = {}, anchorEl = null) => {
    this.setState({
      location: v,
      locationType,
      station: data,
      anchorEl
    });
  };

  onToggleType = (e) => {   
    let value = e.target.checked;
    let type = value ? 'combine' : 'add';
    if(type === 'combine') {
      this.fetchAirlineCombination();
    }
    this.setState({ type });
  };

  onChangeTab = (e) => {
    if (e.target.value !== this.state.tab)
      this.setState({ tab: e.target.value }, () => {
        // e.target.value == 'logs' ? this.fetchLogs() : this.fetchContract();
        e.target.value == 'combineAirlines' ? this.fetchAirlineCombination() : null;
      });
  };

  render() {
    return (
      <>
        <HandledAirlines
          airlineList={this.state.airlineList}
          comboairlineList={this.state.comboairlineList}
          combinationList={this.state.combinationList}
          fetchAirlineCombination={this.fetchAirlineCombination}
          handleClose={this.handleClose}
          locationModal={this.state.locationModal}
          handleOpen={this.handleOpen}
          onChange={this.onChange}
          openAddAirline={this.state.openAddAirline}
          // openCombineAirline={this.state.openCombineAirline}
          airlineFields={this.state.airlineFields}
          airlineErrors={this.state.airlineErrors}
          combineAirlineFields={this.state.combineAirlineFields}
          combineAirlineErrors={this.state.combineAirlineErrors}
          onChangeCombineAirline={this.onChangeCombineAirline}
          addAirline={this.addEditAirline}
          type={this.state.type}
          anchorEl={this.state.anchorEl}
          location={this.state.location}
          locationType={this.state.locationType}
          handleLocation={this.handleLocation}
          stations={this.props.stations}
          station={this.state.station}
          setActive={this.setActive}
          addAirlineCombination={this.addAirlineCombination}
          updateAirlineCombination={this.updateAirlineCombination}
          deleteAirlineCombination={this.deleteAirlineCombination}
          handleCombineEdit={this.handleCombineEdit}
          onToggleType={this.onToggleType}
          tab={this.state.tab}
          onChangeTab={this.onChangeTab}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return { stations: state.stations };
};


const mapDispatchToProps = (dispatch) => {
  return { setDelete: (data) => dispatch(setDeleteAction(data)) };
};

export default connect(mapStateToProps, mapDispatchToProps)(HandledAirlinesContainer);
